import _ from 'lodash';

/**
 * Number of days in month.
 *
 * @param {number} y - year.
 * @param {number} m - month.
 * @returns {number}
 */
const getNumberOfDays = (y, m) => new Date(y, m < 11 ? m + 1 : 0, 0).getDate();

/**
 * Count how many hours between two timestamps.
 *
 * @param {number} end - timestamp of event end.
 * @param {number} start - timestamp of event start.
 * @returns {number}
 */
const getHoursFromTimestamps = (end, start) => {
  const time = (end - start) / 3600;

  return parseFloat(time.toFixed(2), 10);
};

/**
 * Tell`s you how many days in year.
 *
 * @param {number} year
 * @returns {number}
 */
const getDaysOfYear = year => (isLeapYear(year) ? 366 : 365);

/**
 * Tell`s you if this this is leap year.
 * @param {number} year
 * @returns {boolean}
 */
const isLeapYear = year => year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0);

/**
 * What day of the week is this date
 *
 * @param {number} y - year.
 * @param {number} m - month.
 * @param {number} d - date.
 * @returns {number}
 */
const getDayOfWeek = (y, m, d) => new Date(y, m, d).getDay();

/**
 * Turns timestamp to string in format of <hours>:<minutes>.
 *
 * @param{number} timestamp
 * @returns {string}
 */
const getHM = timestamp => {
  const date = new Date(timestamp * 1000);
  const h = date.getHours() > 9 ? date.getHours() : `0${date.getHours()}`;
  const m = date.getMinutes() > 9 ? date.getMinutes() : `0${date.getMinutes()}`;
  return `${h}:${m}`;
};

/**
 * Split events array on array of two arrays:
 * first one is the unique for this time interval events or first of events, that have intersections
 * and all others.
 *
 * @param array
 * @returns {array}
 */
const splitEventsArray = array => {
  let firstArray = [...array];
  let secondArray = [];

  for (let i = 0; i < firstArray.length; i += 1) {
    const item = firstArray[i];

    // eslint-disable-next-line no-loop-func
    const partition = _.partition(firstArray, o => {
      const j = firstArray.indexOf(o);
      return i !== j && (
        (o.date_start >= item.date_start && o.date_start <= item.date_end) ||
        (o.date_end >= item.date_start && o.date_end <= item.date_end)
      );
    });

    // eslint-disable-next-line prefer-destructuring
    firstArray = partition[1];
    secondArray = _.uniq([...secondArray, ...partition[0]]);
  }

  return [firstArray, secondArray];
};

/**
 * Loops splitEventsArray function util there`s events in primary array.
 *
 * @param {array} gamesArr - games array.
 * @returns {array}
 */
const splitLoop = gamesArr => {
  let array = [...gamesArr];

  do {
    const newSplit = splitEventsArray(array[array.length - 1]);
    array.splice(array.length - 1, 1);
    array = [...array, ...newSplit];
  } while (array[array.length - 1].length);

  array.splice(array.length - 1, 1);

  return array;
};

/**
 * Get events between two dates.
 *
 * @param {object} events
 * @param {object} from - { @param {number} year, @param {number} month, @param {number} date }
 * @param {object} to - { @param {number} year, @param {number} month, @param {number} date }
 * @param {bool} includeEndings - include event ending or not (default is false).
 * @returns {array}
 */
const getEvents = (events, from, to, includeEndings = false) => {
  const timestamps = {
    start: new Date(from.year, from.month, from.date).getTime(),
    end: new Date(to.year, to.month, to.date).getTime()
  };

  const prepEvents = from.year === to.year
    ? events[from.year]
    : [...events[from.year], ...events[to.year]];

  return _.filter(prepEvents, o => {
    if (!includeEndings) {
      return o.date_start >= (timestamps.start / 1000) && o.date_start <= (timestamps.end / 1000);
    }

    return (o.date_start >= (timestamps.start / 1000) && o.date_start <= (timestamps.end / 1000)) ||
      (o.date_end >= (timestamps.start / 1000) && o.date_end <= (timestamps.end / 1000)) ||
      (o.date_start <= (timestamps.start / 1000) && o.date_end >= (timestamps.end / 1000));
  });
};

/**
 * Main games filter function.
 *
 * @param {object} games
 * @param {object} filters
 * @returns {object}
 */
const filterGames = (games, filters) => {
  if (_.isEmpty(filters)) return games;

  return _.mapValues(games, o => (_.filter(o, g => {
    const isNotAccepted = Object.keys(filters).map(k => {
      if (k === 'gameType') return filters[k] ? g.type === filters[k] : true;

      return filters[k] ? g[k] === filters[k] : true;
    }).includes(false);

    return !isNotAccepted;
  })));
};

export {
  getNumberOfDays,
  getHoursFromTimestamps,
  getDaysOfYear,
  getDayOfWeek,
  getHM,
  isLeapYear,
  splitEventsArray,
  splitLoop,
  getEvents,
  filterGames
};



// WEBPACK FOOTER //
// ./src/utils/utils.js